module.exports = __webpack_public_path__ + "img/qrCode.d01337d5.png";